module.exports = __webpack_public_path__ + "05_mole.10855fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer2/05_mole.png
// module id = IMcz
// module chunks = 0